import script from "./DashboardLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&setup=true&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=44c02388&lang=scss&scoped=true"
import "./DashboardLayout.vue?vue&type=style&index=1&id=44c02388&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44c02388"]])

export default __exports__